import React from 'react';
import OfferCard from './OfferCard';

import './styles.scss';

const OfferSection = ({ sectionData }) => (
  <div className="offersSection">
    <h3>{sectionData?.header}</h3>
    <div className="scrollWrapper hideScrollbar">
      <div className="offersWrapper">
        {sectionData?.cards?.map((cardData, i) => (
          <OfferCard
            key={cardData?.id}
            cardData={cardData}
            sectionIndex={sectionData?.order}
            cardIndex={i}
          />
        ))}
      </div>
    </div>
  </div>
);
export default OfferSection;
